var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountingEntryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3115 8.36243L24.3363 7.49377C22.4202 6.0007 20.0965 5.12362 17.6715 4.97813C15.2465 4.83265 12.8341 5.42559 10.7522 6.67881C8.67039 7.93202 7.01687 9.78667 6.00964 11.9983C5.00242 14.2099 4.68877 16.6746 5.11004 19.0675M7.97908 25.1652L9.55246 26.3998C11.4709 27.8943 13.7975 28.7719 16.2253 28.9167C18.6531 29.0615 21.068 28.4668 23.1514 27.2109C25.2349 25.9551 26.889 24.0971 27.8955 21.8822C28.9021 19.6673 29.2138 17.1995 28.7895 14.8043",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49654 27.3876L6.56994 24.2615L9.22984 23.2863M25.5007 5.60198L25.3758 8.72799L22.3049 9.30789",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 5.00024V29.0002",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5001 15.0002L21.5001 19.5002L20.0001 17.2502",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00012 19.5002L13.5001 15.0002M13.5001 19.5002L9.00012 15.0002",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountingEntryIcon);
export default __webpack_public_path__ + "static/media/accountingEntryIcon.b410e463c8281f011ac7a1e2b1aa754f.svg";
export { ForwardRef as ReactComponent };